const DEFAULT_LNG = -75.6960287
const DEFAULT_LAT = 40.004634
const DEFAULT_ZOOM = 10

export default (currentFilters = {}, preference = {}, collegeCoords = []) => {
  const CURRENT_LNG = currentFilters.longitude
  const PREF_LNG = preference.Longitude
  const COLLEGE_LNG = collegeCoords[0]
  const longitude = CURRENT_LNG || PREF_LNG || COLLEGE_LNG || DEFAULT_LNG

  const CURRENT_LAT = currentFilters.latitude
  const PREF_LAT = preference.Latitude
  const COLLEGE_LAT = collegeCoords[1]
  const latitude = CURRENT_LAT || PREF_LAT || COLLEGE_LAT || DEFAULT_LAT

  const CURRENT_ZOOM = currentFilters.zoom
  const PREF_ZOOM = preference.Zoom
  const zoom = CURRENT_ZOOM || PREF_ZOOM || DEFAULT_ZOOM

  return {
    longitude,
    latitude,
    zoom,
  }
}
